module.exports = "/_next/static/files/2b8ef96eb820a5b30f8dacc5915d3f01.jpg";